import { useRouteLoaderData } from 'react-router'

import { AppLoaderData } from '~/portal/types/app'
import { AmplitudeData } from '~/shared/types/amplitude'
import { SWAGGERHUB_ROLE } from '~/shared/types/shub'
import { UserInfo } from '~/shared/types/user.ts'

export const useUser = (): { user?: UserInfo; isLoggedIn: boolean; amplitudeData?: AmplitudeData, organizationRole?: SWAGGERHUB_ROLE } => {
  const data = useRouteLoaderData<AppLoaderData>('root')
  const user = data?.user
  const amplitudeData = data?.amplitudeData
  const isLoggedIn = Boolean(user?.email)
  const organizationRole = data?.organizationRole
  return {
    user,
    amplitudeData,
    isLoggedIn,
    organizationRole,
  }
}